import VppPlans from "../js/components/configuration/vppPlans/VppPlans.react";
export default VppPlans;
